import React, { useContext } from 'react';

/**
 * @type {React.Context<import('.').FieldProps>}
 */
export const FieldContext = React.createContext({
  status: 'default',
  disabled: false,
  value: undefined,
  name: undefined,
  onChange: undefined,
});

/**
 *
 * @type {import('.').UseFieldContextType}
 */
export const useFieldContext = ({ ...props }) => {
  const context = useContext(FieldContext);
  return {
    ...context,
    ...props,
  };
};
